import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { DownloadCsv } from '../../../../../common/downloadCsv'
import { DownloadJpg } from '../../../../../common/downloadJpg'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { SelectCustom } from '../../../../../common/selectCustom'
import { selectCompanyInfo } from '../../../../common/header/companyInfo/store/slice'
import { GDP_TAB, MACROECONOMICS_TAB, VIEW_BY } from '../constant'
import { selectYear as selectFDIYear } from '../fdi/store/slice'
import { selectTab as selectGDPGrowthRateTab } from '../gdp/gdpChart/chartGrowthRate/slice'
import { selectTab as selectGDPIndustryTab } from '../gdp/gdpChart/chartIndustry/slice'
import { selectTab } from '../gdp/gdpTable/slice'
import { selectYear as selectGDPYear } from '../gdp/store/slice'
import { selectYear as selectImportExportYear } from '../importExport/store/slice'
import { changeViewBy, selectActiveTab, selectViewBy } from '../store/slice'
import { exportMacroeconomics } from '../store/thunk'
import classes from './index.module.scss'

export const Right = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { currency, multiplier, unitName } = useFormatCurrency(
    SCREEN.INDUSTRY_OVERVIEW,
  )

  const { organizationShortName, organizationName, taxCode } =
    useSelector(selectCompanyInfo)
  const tab = useSelector(selectTab)
  const activeTab = useSelector(selectActiveTab)
  const viewBy = useSelector(selectViewBy)
  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const gdpGrowthRateTab = useSelector(selectGDPGrowthRateTab)
  const gdpIndustryTab = useSelector(selectGDPIndustryTab)
  const importExportYear = useSelector(selectImportExportYear)
  const gdpYear = useSelector(selectGDPYear)
  const fdiYear = useSelector(selectFDIYear)
  const label1 = UseI18n(
    'industryOverview.macroeconomics.FDI_CURRENT_PRICE_GROWTH_RATE',
  )
  const label2 = UseI18n('industryOverview.macroeconomics.FDI_BY_INDUSTRIES')
  const label3 = UseI18n(
    'industryOverview.macroeconomics.IMPORT_EXPORT_GROWTH_RATE',
  )
  const label4 = UseI18n(
    'industryOverview.macroeconomics.IMPORT_EXPORT_TRADE_VALUE',
  )
  const label5 = UseI18n('industryOverview.macroeconomics.IMPORT_EXPORT_PRICE')
  const label6 = UseI18n(
    'industryOverview.macroeconomics.' +
      (gdpGrowthRateTab === GDP_TAB.REAL_GDP.key
        ? 'REAL_GDP_GROWTH_RATE'
        : 'NOMINAL_GDP_GROWTH_RATE'),
  )
  const label7 = UseI18n(
    'industryOverview.macroeconomics.' +
      (gdpIndustryTab === GDP_TAB.REAL_GDP.key
        ? 'REAL_GDP_INDUSTRY'
        : 'NOMINAL_GDP_INDUSTRY'),
  )

  const chooseItem = (item) => {
    dispatch(changeViewBy(item))
  }

  const downloadCsv = () => {
    const paramMacro =
      activeTab === MACROECONOMICS_TAB.GDP.key
        ? tab === GDP_TAB.REAL_GDP.key
          ? 'RealGDP'
          : 'NominalGDP'
        : Object.values(MACROECONOMICS_TAB).find(
            (item) => item.key === activeTab,
          ).value

    return exportMacroeconomics({
      organizationId,
      currency,
      currencyUnit: {
        multiplier,
        value: unitName,
      },
      macroeconomicsType: paramMacro,
    })
  }

  const getArrName = (label) => {
    return [label, organizationShortName || organizationName || taxCode || '']
  }

  const renderDownloadImg = () => {
    switch (activeTab) {
      case MACROECONOMICS_TAB.GDP.key:
        return (
          <DownloadJpg
            data={{
              disabled: false,
              arrName: getArrName(label6),
              domId: 'macroGDPChartGrowthRateId',
              titleJpg: label6,
            }}
          >
            <DownloadJpg
              data={{
                disabled: false,
                arrName: getArrName(label7 + ' - ' + gdpYear),
                domId: 'macroDGPChartIndustryId',
                titleJpg: label7 + ' - ' + gdpYear,
              }}
            />
          </DownloadJpg>
        )
      case MACROECONOMICS_TAB.FDI.key:
        return (
          <DownloadJpg
            data={{
              disabled: false,
              arrName: getArrName(label1),
              domId: 'macroChartGrowthFDIId',
              titleJpg: label1,
            }}
          >
            <DownloadJpg
              data={{
                disabled: false,
                arrName: getArrName(label2 + ' - ' + fdiYear),
                domId: 'macroFDIChartIndustryId',
                titleJpg: label2 + ' - ' + fdiYear,
              }}
            />
          </DownloadJpg>
        )
      default:
        return (
          <DownloadJpg
            data={{
              disabled: false,
              arrName: getArrName(label3),
              domId: 'macroImportExportGrowthRateId',
              titleJpg: label3,
            }}
          >
            <DownloadJpg
              data={{
                disabled: false,
                arrName: getArrName(label4),
                domId: 'macroImportExportValueId',
                titleJpg: label4,
              }}
            >
              <DownloadJpg
                data={{
                  disabled: false,
                  arrName: getArrName(label5 + ' - ' + importExportYear),
                  domId: 'macroImportExportRightId',
                  titleJpg: label5 + ' - ' + importExportYear,
                }}
              />
            </DownloadJpg>
          </DownloadJpg>
        )
    }
  }

  return (
    <div className={classes.right}>
      <SelectCustom
        isI18n
        className="fw600"
        activeItem={viewBy}
        data={Object.values(VIEW_BY)}
        chooseItem={chooseItem}
        style={{ borderColor: '#FFFFFF' }}
      />
      {viewBy === VIEW_BY.TABLE ? (
        <DownloadCsv downloadCsv={downloadCsv} disabled={false} />
      ) : (
        renderDownloadImg()
      )}
    </div>
  )
}
